<template>
    <div>
        <div class="col-12 position-relative">
            <label class="form-label" for="extras">
                <strong>{{ $t('Add existing extra') }}</strong>
            </label>
            <input class="form-control autocomplete" aria-label="Extra Service" ref="autocomplete" id="autocomplete" :placeholder="$t('Search...')" @keyup="searchExtras($event)">
            <div id="output" v-if="showSuggestions">
                <ul>
                    <li v-for="extraItem in allExtrasFiltered" @click="selectExtraService(extraItem.id)">{{ extraItem.name }}</li>
                </ul>
            </div>
        </div>

        <div class="col-12 text-left extraServices">
            <div v-if="typeof this.extras.data !== 'undefined' && this.extras.data.length > 0">
                <div class="row head pt-2 font-bold text-sm">
                    <div class="col-md-2">{{ $t('Service title') }}</div>
                    <div class="col-md-2">{{ $t('Image') }}</div>
                    <div class="col-md-1 text-center">{{ $t('Price') }}</div>
                    <div class="col-md-2 text-center">{{ $t('Discount') }}</div>
                    <div class="col-md-2 text-center">{{ $t('Duration') }}</div>
                    <div class="col-md-1 text-center">{{ $t('Max') }}</div>
                    <div class="col-md-2 text-center"></div>
                </div>
                <div class="row p-2" v-for="item in this.extras.data" :key="item.id">
                    <div class="col-md-2 p-2 text-wrap">{{ item.name }}</div>
                    <div class="col-md-2 p-2">
                        <img :src="item.photo_path" alt="" class="d-block mb-1" style="max-width:100px" v-if="item.photo_path">
                        <span v-else>{{ $t('N/A') }}</span>
                    </div>
                    <div class="col-md-1 p-2 text-center">{{ currencySymbol }}{{ item.price }}</div>
                    <div class="col-md-2 p-2 text-center">{{ item.discount }}</div>
                    <div class="col-md-2 p-2 text-center">{{ item.title.replace('No wait time', '0 min.') }}</div>
                    <div class="col-md-1 p-2 text-center">{{ item.extra_max_quantity }}</div>
                    <div class="col-md-2 text-center">
                        <a class="btn btn-square btn-neutral rounded-circle p-2" @click="edit(item.id)"><span class="svg-icon"><i class="bi bi-pen"></i></span></a>
                        <a class="btn btn-square btn-danger rounded-circle p-2 ms-2" @click="remove(item.id)"><span class="svg-icon"><i class="bi bi-archive"></i></span></a>
                    </div>
                </div>
            </div>
            <span v-else>{{ $t('No extra services.') }}</span>
        </div>
    </div>
    <div class="modal-mask" v-if="showModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ $t('Edit') }} {{ extra.name }}</h5>
                    <button type="button" class="btn-close" @click="this.showModal=false;" aria-label="Close"></button>
                </div>
                <div class="modal-body pt-0">
                    <div class="row">
                        <div class="col-12 mt-5 mb-5">
                            <label class="form-label" for="title">{{ $t('Title') }}:</label>
                            <input type="text" class="form-control" id="name" name="name" :placeholder="$t('Title')" v-model="extra.name">
                        </div>
                        <div class="col-md-12 mb-5">
                            <label class="form-label">{{ $t('Image') }}</label>
                            <div class="mb-2" v-if="extra.photo_path && showImagePreview">
                                <img :src="extra.photo_path" alt="" class="d-block mb-1" style="max-width:100px">
                                <a href="#" @click="removeImage" class="text-primary text-sm">{{ $t('Remove') }}</a>
                            </div>
                            <input id="extra_image" type="file" class="form-control" name="image" accept="image/*" @change="imageChange">
                            <div class="mt-2 note form-label">{{ $t('Square (1:1) format is recommended') }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label class="form-label" for="price">{{ $t('Price') }} ({{ currencySymbol }})</label>
                            <input type="text" class="form-control" id="price" name="price" :placeholder="$t('Price')" max="9999" onkeypress='validateNumAndSpecChars(event)' v-model="extra.price">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label" for="discount">{{ $t('Discount') }} (%)</label>
                            <input type="text" class="form-control" id="discount" name="discount" :placeholder="$t('Discount')" max="100" onkeypress='validateNumAndSpecChars(event)' v-model="extra.discount">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label" for="durations">{{ $t('Duration') }}</label>
                            <select class="form-select" id="durations" name="duration" v-model="extra.duration">
                                <option v-for="duration in durations" :value="duration.id">
                                    {{ duration.title.replace('No wait time', '0 min.') }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label" for="qty">{{ $t('Max. quantity') }}</label>
                            <input type="text" class="form-control" id="qty" name="qty" placeholder="Quantity" min="1" max="100" onkeyup="validateMin(event)" onkeypress='validateNumAndSpecChars(event)' v-model="extra.extra_max_quantity">
                        </div>
                    </div>
                </div>
                <div class="modal-footer px-8 pb-8">
                    <a href="#" class="btn btn-success" @click="saveExtra">{{ $t('Save') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: scroll;
}
.form-check-input {
    width: 30px;
    height: 30px;
}
#output {
    position: absolute;
    background: #fff;
    box-shadow: 0 2px 6px #ccc;
    border-radius: 5px;
    width: 100%;
}
#output ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
#output ul li {
    padding: 1em;
}
#output ul li:hover {
    background: #efefef;
    cursor: pointer;
}
</style>

<script>
import Form from "../helpers/Form";
import Notification from "../helpers/Notification.vue";
import LocationSettings from "../helpers/LocationSettings.vue";

export default {
    mixins: [Form, LocationSettings],
    props: [
        'service_id'
    ],
    data: function () {
        return {
            extras: [],
            extra: {},
            durations: [],
            showImagePreview: true,
            currencySymbol: window.currencySymbol,
            showModal: false,
            allExtras: [],
            allExtrasFiltered: [],
            showSuggestions: false,
        }
    },
    methods: {
        getExtras() {
            return axios
                .get(`/api/admin/services/${this.service_id}/extras`)
                .then(res => {
                    this.extras = res.data;
                });
        },
        getAllExtras() {
            return axios
                .get(`/api/admin/services/extras?paginate=1000`)
                .then(res => {
                    this.allExtras = res.data.data;
                });
        },
        edit(id) {
            this.extra = this.extras.data.find((item) => item.id === id);
            this.extra.duration = this.extra.time_intervals_id;

            this.showModal = true;
        },
        saveExtra() {
            this.extra.qty = this.extra.extra_max_quantity;

            let data = new FormData();
            data.append('name',this.extra.name);
            data.append('price', this.extra.price);
            data.append('duration', this.extra.duration);
            data.append('discount', this.extra.discount);
            data.append('qty', this.extra.qty);

            if (this.extra.photo_changed) {
                data.append('photo_path', this.extra.photo_path);
                data.append('photo_changed', this.extra.photo_changed);
            }

            axios
                .post(`/api/admin/services/${this.service_id}/extras/${this.extra.id}/update`, data, {
                    headers: { 'content-type': 'multipart/form-data' }
                })
                .then(res => {
                    this.showModal = false;
                    this.onSuccess(res.data.message);
                    this.getExtras();
                    this.getAllExtras();
                    this.clearSuggestions();
                })
                .catch((error) => {
                    if (error && error.response.status === 422) {
                        if(error.response.data.errors !== undefined) {
                            this.setErrors(error.response.data.errors);
                        } else {
                            Notification.methods.warning(error.response.data.message);
                        }
                    } else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        getDurations() {
            axios
                .get('/api/admin/extras/durations')
                .then(res => {
                    this.durations = res.data.data;
                });
        },
        removeImage() {
            this.extra.photo_path = null;
            this.extra.photo_changed = true;
        },
        imageChange(e) {
            this.showImagePreview = false;
            this.extra.photo_path = e.target.files[0];
            this.extra.photo_changed = true;
        },
        remove(id) {
            axios
                .delete(`/api/admin/services/${this.service_id}/extras/${id}`)
                .then(res => {
                    this.onSuccess(res.data.message);
                    this.getExtras();
                    this.getAllExtras();
                    this.clearSuggestions();
                })
                .catch((error) => {
                    if (error && error.response.status == 422) {
                        this.setErrors(error.response.data.errors);
                    } else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        searchExtras(e) {
            const value = e.target.value;

            if (value.length < 2) {
                this.showSuggestions = false;
                return;
            }

            this.allExtrasFiltered = this.allExtras.filter((item) => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);

            this.showSuggestions = this.allExtrasFiltered.length;
        },
        selectExtraService(id) {
            this.clearSuggestions();

            axios
                .post(`/api/admin/services/${this.service_id}/extras/${id}`)
                .then(res => {
                    this.onSuccess(res.data.message);
                    this.getExtras();
                    this.getAllExtras();
                })
                .catch((error) => {
                    if (error && error.response.status == 422) {
                        this.setErrors(error.response.data.errors);
                    } else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        reloadAutocomplete() {
            if (!this.extras.data.length) {
                return;
            }

            const existingIds = this.extras.data.map(i => i.id);
            this.allExtras = this.allExtras.filter(i => !existingIds.includes(i.id));
        },
        clearSuggestions() {
            this.showSuggestions = false;
            this.$refs.autocomplete.value = '';
        },
        loadExtras() {
            this.getDurations();
            Promise.all([this.getExtras(), this.getAllExtras()]).then(() => this.reloadAutocomplete());
        }
    },
    mounted() {
    }
}
</script>
